import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { hideToast } from '../../app/store/toastSlice';
import { runToastAction } from '../../utils/toast';

/**
 * Global, app-wide toast. Renders the current toast from the `toast` slice with
 * an optional action button (Retry/Reload/Contact support/etc.). Mounted once.
 */
export default function AppToast() {
  const dispatch = useAppDispatch();
  const { open, message, severity, actionLabel, actionId, autoHideMs } = useAppSelector((state) => state.toast);

  const close = () => dispatch(hideToast());

  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideMs ?? undefined}
      onClose={(_event, reason) => { if (reason !== 'clickaway') close(); }}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert
        severity={severity}
        variant="filled"
        sx={{ alignItems: 'center' }}
        action={
          <>
            {actionLabel && actionId && (
              <Button color="inherit" size="small" onClick={() => runToastAction(actionId)}>
                {actionLabel}
              </Button>
            )}
            <IconButton aria-label="Dismiss" color="inherit" size="small" onClick={close}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </>
        }
      >
        {message}
      </Alert>
    </Snackbar>
  );
}
